import { render } from "./BpNotify.vue?vue&type=template&id=55153d13&scoped=true"
import script from "./BpNotify.vue?vue&type=script&lang=js"
export * from "./BpNotify.vue?vue&type=script&lang=js"

import "./BpNotify.vue?vue&type=style&index=0&id=55153d13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55153d13"]])

export default __exports__